// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface MongoDBResourcesListMongoUserDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesDeleteMongoUserDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesCreateUpdateMongoUserDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoUserDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesListMongoRoleDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesDeleteMongoRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesCreateUpdateMongoRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoRoleDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesRetrieveContinuousBackupInformationOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesListMongoDBCollectionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesDeleteMongoDBCollectionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesCreateUpdateMongoDBCollectionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoDBCollectionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesListMongoDBDatabasesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesDeleteMongoDBDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesCreateUpdateMongoDBDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoDBDatabaseOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesMigrateMongoDBCollectionToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesMigrateMongoDBCollectionToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesUpdateMongoDBCollectionThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoDBCollectionThroughputOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface MongoDBResourcesMigrateMongoDBDatabaseToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesMigrateMongoDBDatabaseToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesUpdateMongoDBDatabaseThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface MongoDBResourcesGetMongoDBDatabaseThroughputOptionalParams extends OperationOptions {}
